import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from "../../../../../app/store";
import {offerApi, RequestStatus} from "../../../../../api/apiConfiguration";
import {CreateOfferRequest, OfferInListDTO, OfferTableRequest, OfferTableResponse} from "../../../../../api/generated";

export interface SaveNewOffersModalState {
    existOffersList: OfferInListDTO[]
    newOffersList: OfferInListDTO[]
    existOffersListRequestStatus: RequestStatus
    saveNewOffersRequestStatus: RequestStatus
}

const buildInitialState = (): SaveNewOffersModalState => {
    return {
        existOffersList: [],
        newOffersList: [],
        existOffersListRequestStatus: RequestStatus.NONE,
        saveNewOffersRequestStatus: RequestStatus.NONE,
    }
}

const initialState: SaveNewOffersModalState = buildInitialState()

export const fetchExistOffersList = createAsyncThunk<OfferTableResponse, OfferTableRequest, {
    state: RootState
}>(
    "saveNewOffersModalSlice/fetchExistOffersList",
    (payload) => {
        return offerApi.getOfferTable({
            offerTableRequest: payload
        });
    }
);

export const saveNewOffers = createAsyncThunk<OfferInListDTO[], CreateOfferRequest[], {
    state: RootState
}>(
    "saveNewOffersModalSlice/saveNewOffers",
    (payload) => {
        return offerApi.createOffersFromCSV({
            createOfferRequest: payload
        });
    }
);

export const saveNewOffersModalSlice = createSlice({
    name: 'saveNewOffersModalSlice',
    initialState,
    reducers: {
        clearSaveNewOffersModelSlice: () => {
            return buildInitialState();
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchExistOffersList.pending, (state) => {
            state.existOffersListRequestStatus = RequestStatus.PENDING;
        });
        builder.addCase(fetchExistOffersList.fulfilled, (state, {payload}) => {
            state.existOffersList = payload.offers;
            state.existOffersListRequestStatus = RequestStatus.RESOLVED;
        });
        builder.addCase(fetchExistOffersList.rejected, (state) => {
            state.existOffersListRequestStatus = RequestStatus.REJECTED;
        });
        builder.addCase(saveNewOffers.pending, (state) => {
            state.saveNewOffersRequestStatus = RequestStatus.PENDING;
        });
        builder.addCase(saveNewOffers.fulfilled, (state) => {
            state.saveNewOffersRequestStatus = RequestStatus.RESOLVED;
        });
        builder.addCase(saveNewOffers.rejected, (state) => {
            state.saveNewOffersRequestStatus = RequestStatus.REJECTED;
        });
    },
});

export const {
    clearSaveNewOffersModelSlice
} = saveNewOffersModalSlice.actions;

export const existOffersListSelector = (state: RootState) => state.saveNewOffersModal.existOffersList;
export const existOffersListRequestStatusSelector = (state: RootState): RequestStatus => state.saveNewOffersModal.existOffersListRequestStatus;
export const saveNewOffersRequestStatusSelector = (state: RootState): RequestStatus => state.saveNewOffersModal.saveNewOffersRequestStatus;
